<template>
  <main>
    <div class="py-4 pt-5 container-fluid">
      <GridRow>
        <GridCol>
          <MetaSection>
            <div class="text-right">
              <ArgonButton :to="{ name: 'Aspek KPI' }" isRouteLink>Kembali</ArgonButton>
            </div>
          </MetaSection>
        </GridCol>
        <GridCol>
          <form action="" @submit.prevent="submit()">
            <cards footerstyle="background-color: #ebeffb;" :useFooter="true">
              <template v-slot:footer>
                <div class="text-right">
                  <div class="d-flex flex-row-reverse gap-2">
                    <ArgonButton type="submit">Simpan</ArgonButton>
                    <ArgonButton :to="{ name: 'Aspek KPI' }" isRouteLink outline>Batalkan</ArgonButton>
                  </div>
                </div>
              </template>
              <FieldsetComponent title="Aspek Penilaian Kerja"
                description="Pastikan nama aspek dan nilai minimal & maksimal sesuai dengan pedoman Rating untuk master data KPI.">
                <div class="flex flex-col gap-5">
                  <form-group label="Nama Aspek Penilaian Kerja" hint='Contoh “Nominal Transaksi Luar Negeri”'
                    idinput="name" invalidmsg="Nama tidak valid">
                    <input-form name="name" idinput="name"
                      placeholder="Silakan tulis nama aspek penilaian kinerja disini..." v-model="data.name" :isinvalid="!validateInput('name', data.name)" />
                  </form-group>

                  <div class="d-flex flex-column gap-3">
                    <div v-for="index in 5" :key="index" class="border p-2">
                      <FieldsetComponent :isFieldsetRow="true" :title="'Nilai ' + index">
                        <GridRow>
                          <div class="col-md">
                            <FormGroup label="Nilai minimal">
                              <GridRow>
                                <div class="col">
                                  <FormGroup label="Operator" :idinput="'nilai' + index + '_min_operator'"
                                    invalidmsg="Range tidak valid">
                                    <select-form :name="'nilai' + index + '_min_operator'" @change="validateAspek(index)"
                                      :idinput="'nilai' + index + '_min_operator'" :isinvalid="this['error_aspek_'+ index]" v-model="data['nilai' + index + '_min_operator']" :options="Object.keys(operator).map((item,index) => {
                                        return {
                                          value: item,
                                          text: item,
                                        };
                                      })" />
                                  </FormGroup>
                                </div>
                                <div class="col">
                                  <FormGroup label="Angka" :idinput="'nilai' + index + '_min'"
                                    invalidmsg="Range tidak valid">
                                    <input-form type="number" v-model="data['nilai' + index + '_min']"
                                      :name="'nilai' + index + '_min'" :idinput="'nilai' + index + '_min'"
                                      @keyup="validateAspek(index)"
                                      placeholder="Silakan tulis nama aspek penilaian kinerja disini..." step="0.001"
                                      :isinvalid="this['error_aspek_'+ index]" />
                                  </FormGroup>
                                </div>
                              </GridRow>
                            </FormGroup>
                          </div>
                          <div class="col-md">
                            <FormGroup label="Nilai Maksimal">
                              <GridRow>
                                <div class="col">
                                  <FormGroup label="Operator" :idinput="'nilai' + index + '_max_operator'"
                                    invalidmsg="Range tidak valid">
                                    <select-form :name="'nilai' + index + '_max_operator'" @change="validateAspek(index)"
                                      :idinput="'nilai' + index + '_max_operator'" :isinvalid="this['error_aspek_'+ index]" v-model="data['nilai' + index + '_max_operator']" :options="Object.keys(operator).map((item,index) => {
                                        return {
                                          value: item,
                                          text: item,
                                        };
                                      })" />
                                  </FormGroup>
                                </div>
                                <div class="col">
                                  <FormGroup label="Angka" :idinput="'nilai' + index + '_max'"
                                    invalidmsg="Range tidak valid">
                                    <input-form
                                      type="number"
                                      v-model="data['nilai' + index + '_max']"
                                      :name="'nilai' + index + '_max'"
                                      :idinput="'nilai' + index + '_max'"
                                      placeholder="Silakan tulis nama aspek penilaian kinerja disini..."
                                      step="0.001"
                                      @keyup="validateAspek(index)"
                                      :isinvalid="this['error_aspek_'+ index]"
                                      min="0"
                                      />
                                  </FormGroup>
                                </div>
                              </GridRow>
                            </FormGroup>
                          </div>
                        </GridRow>
                      </FieldsetComponent>
                    </div>
                  </div>

                  <form-group v-if="this.$route.params.id" label="Status">
                    <div class="d-flex flex-row gap-4 align-items-center">
                      <input style="width: 2rem;height: 2rem;" type="radio" value="1" v-model="data.status" name="status"
                        id="status_0" autocomplete="off">
                      <label class="m-0" :for="'status_0'">Aktif</label>

                      <input style="width: 2rem;height: 2rem;" type="radio" value="0" v-model="data.status" name="status"
                        id="status_1" autocomplete="off">
                      <label class="m-0" :for="'status_1'">Non Aktif</label>
                    </div>
                  </form-group>
                </div>
              </FieldsetComponent>
            </cards>
          </form>
        </GridCol>
      </GridRow>
    </div>
  </main>
</template>

<script>
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
import AspekKinerjaApi from "@/repository/api/AspekKinerjaApi";
import UnitKerjaApi from "@/repository/api/UnitKerjaApi";
import JabatanApi from "@/repository/api/JabatanApi";
import RealisasiKpiApi from "@/repository/api/RealisasiKpiApi";
import FieldsetComponent from "@/views/components/FieldsetComponent.vue";
import EmployeeApi from "@/repository/api/EmployeeApi";
import ArgonButton from "@/components/ArgonButton.vue"
import MetaSection from '@/components/MetaSection.vue';
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
import InputForm from '@/components/InputForm.vue';
import SelectForm from '@/components/SelectForm.vue';
import { compareValues } from '@/utils/Extenstion';


export default {
  name: "profile",
  data() {
    return {
      operator: {
        "<": "<",
        "<=": "<=",
        ">": ">",
        ">=": ">=",
        "=": "=",
      },
      showMenu: false,
      data: {},
      error_aspek_1: false,
      error_aspek_2: false,
      error_aspek_3: false,
      error_aspek_4: false,
      error_aspek_5: false,
      unitKerja: [
        {}
      ],
      employee: [{}],
      selectedEmployeeAdd: "",
      optionEmployee: [
        {
          id: "abc",
          text: "xyz",
        },
      ],
      validatedRange: [true, true, true, true, true],
      jabatan: [],
      optionUnitKerja: [],
      optionJabatan: [],
      myValue: '',
      submitable: true,
    };
  },
  components: {
    FieldsetComponent,
    Cards,
    FormGroup,
    ArgonButton,
    MetaSection,
    GridRow,
    GridCol,
    InputForm,
    SelectForm,
  },
  watch: {
  },

  async mounted() {
    if (this.$route.params.id) {
      await this.getData();
    }
    // await this.getEmployee();
  },
  methods: {
    validateInput(field, data) {
      let test = Boolean
      switch (field) {
        case "name":
          test = /^([\w!@#$%^&*(),.?":{}|<>-](\s?))+$/.test(data)
          break;
        default:
          break;
      }
      this.submitable = test
      return test;
    },
    validateAspek(nilai) {
      let result = true;
      // console.log('\nRange Nilai '+ nilai)
      // console.log(this.new_aspek.aspekkinerja['nilai'+ nilai +'_min'], this.new_aspek.aspekkinerja['nilai'+ nilai +'_min_operator'], 'X', this.new_aspek.aspekkinerja['nilai'+ nilai +'_max_operator'], this.new_aspek.aspekkinerja['nilai'+ nilai +'_max'])
      
      // console.log('operator min')
      // console.log(this.new_aspek.aspekkinerja['nilai'+ nilai +'_min'], this.new_aspek.aspekkinerja['nilai'+ nilai +'_min_operator'], this.new_aspek.aspekkinerja['nilai'+ nilai +'_max'])
      // console.log(eval(this.new_aspek.aspekkinerja['nilai'+ nilai +'_min'] + this.new_aspek.aspekkinerja['nilai'+ nilai +'_min_operator'] + this.new_aspek.aspekkinerja['nilai'+ nilai +'_max']))
      
      // console.log('operator max')
      // console.log(this.new_aspek.aspekkinerja['nilai'+ nilai +'_min'], this.new_aspek.aspekkinerja['nilai'+ nilai +'_max_operator'], this.new_aspek.aspekkinerja['nilai'+ nilai +'_max'])
      // console.log(eval(this.new_aspek.aspekkinerja['nilai'+ nilai +'_min'] + this.new_aspek.aspekkinerja['nilai'+ nilai +'_max_operator'] + this.new_aspek.aspekkinerja['nilai'+ nilai +'_max']))
      
      try {
        if (
          compareValues(this.data['nilai'+ nilai +'_min_operator'], this.data['nilai'+ nilai +'_max'], this.data['nilai'+ nilai +'_min']) &&
          compareValues(this.data['nilai'+ nilai +'_max_operator'], this.data['nilai'+ nilai +'_min'], this.data['nilai'+ nilai +'_max'])
        ) {
          result = false;
        }
      } catch (error) {
        result = true;
      }

      this['error_aspek_'+ nilai] = result;
    },
    validate() {
      const ketepatan = 0.01
      const data = []
      for (let index = 1; index <= 5; index++) {
        data.push([this.data['nilai' + index + '_min_operator'], this.data['nilai' + index + '_min'], this.data['nilai' + index + '_max_operator'], this.data['nilai' + index + '_max']])
      }
      console.log(JSON.parse(JSON.stringify(data)))
      const str = this.buildRangeStrings(data, ketepatan);
      this.validateRangeStrings(str);
      console.log(str)
      console.log(this.validatedRange)
    },
    buildRangeStrings(data, ketepatan) {
      const str = []
      let temp = ""
      for (let index = 0; index < data.length; index++) {
        if (index == 0) {
          data[index].splice(0, 1)
        }
        if (index > 0) {
          switch (data[index][0]) {
            case '>':
              data[index][1] = String(Number.parseInt(data[index][1]) - ketepatan)
              break;
            case '<':
              data[index][1] = String(Number.parseInt(data[index][1]) + ketepatan)
              break;

            default:
              break;
          }
          data[index][1] = data[index][1] + " && " + data[index][1]
          temp = data[index].join('')
          temp = str[index - 1] + " && " + data[index - 1][data[index - 1].length - 1] + temp
        }
        else {
          temp = data[index].join('')
        }
        // if (index > 0) {
        //     temp = data[index-1][data[index-1].length - 1] + temp
        // }
        str.push(temp)
      }
      return str;
    },
    validateRangeStrings(str) {
      const valid_operators = new Set(['>', '>=', '<', '<=', '=']);
      for (let index = 0; index < str.length; index++) {
        const min_operator = this.data['nilai' + String(index + 1) + '_min_operator'];
        const max_operator = this.data['nilai' + String(index + 1) + '_max_operator'];
        if (!valid_operators.has(min_operator) || !valid_operators.has(max_operator)) {
          this.validatedRange[index] = false;
        }
        else {
          try {
            this.validatedRange[index] = this.evalComparisonChain(str[index]);
          } catch(_error) {
            this.validateRange[index] = false
          }
        }
      }
    },
    // Evaluate an AND-chain of numeric comparisons (e.g. "100<=200 && 200>199.99")
    // without eval(). Each clause is "<operand> <operator> <operand>".
    evalComparisonChain(expr) {
      const operators = ['>=', '<=', '=', '>', '<'];
      const clauses = String(expr).split('&&');
      return clauses.every((clause) => {
        const trimmed = String(clause).trim();
        for (const op of operators) {
          const at = trimmed.indexOf(op);
          if (at > 0) {
            return compareValues(op, trimmed.slice(0, at).trim(), trimmed.slice(at + op.length).trim());
          }
        }
        throw new TypeError('Invalid comparison clause: ' + trimmed);
      });
    },
    getMin(op_min, min) {
      switch (op_min) {
        case ">=":
          return min
        case ">":
          return min + 1
        default:
          return null
      }
    },
    getMax(op_max, max) {
      switch (op_max) {
        case "<=":
          return max;
        case "<":
          return max;
      }
    },
    async unassignKpi(id) {
      this.$swal({
        icon: "warning",
        title: "Apakah anda yakin ingin menghapus?",
        text: "Jika anda unassign pegawai maka progress pegawai tersebut untuk kpi terkait akan ikut dihapus",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;
          await RealisasiKpiApi.delete(id).then(async () => {
            this.$swal({
              icon: "success",
              title: "Berhasil Unassign"
            })
            await this.getRealisasi();
          })
          this.$store.state.loading = false;
        }
      });
    },
    async getEmployee() {
      this.$store.state.loading = true;
      await EmployeeApi.get().then((response) => {
        this.employee = response.data;
        this.optionEmployee = this.employee.map((item) => {
          return {
            id: item.id,
            text: item.name,
          }
        })
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: "ERROR",
          text: error.response.data.message,
        });
      });
      this.$store.state.loading = false;
    },
    async getRealisasi() {
      this.$store.state.loading = true;
      await RealisasiKpiApi.getbyparam({ kpi_id: this.$route.params.id }).then((response) => {
        this.data.realisations = response.data
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: "ERROR",
          text: error.response.data.message,
        });
      })
      this.$store.state.loading = false;
    },
    async assignEmployee(data) {
      this.$store.state.loading = true;
      this.selectedEmployeeAdd = data.id;
      await RealisasiKpiApi.post({
        employee_id: this.selectedEmployeeAdd,
        kpi_id: this.$route.params.id
      }).then(async () => {
        this.$swal({
          icon: "success",
          text: "Assigned"
        })
        await this.getRealisasi();
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: "ERROR",
          text: error.response.data.message,
        });
      });
      this.$store.state.loading = false;
    },
    getSelectedUnitKerja() {
      return this.unitKerja.find((item) => {
        return item.id == this.data.unit_kerja_id;
      });
    },
    async getOptionUnitKerja() {
      this.optionUnitKerja = this.unitKerja.map((item) => {
        return {
          id: item.id,
          text: item.name,
        };
      });
    },
    async getUnitKerja() {
      this.$store.state.loading = true;
      await UnitKerjaApi.get().then(async (response) => {
        this.unitKerja = response.data;
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: "ERROR",
          text: error?.response?.data?.message ?? "Belum ada unit kerja"
        });
      });
      await this.getOptionUnitKerja();
      this.$store.state.loading = false;
    },
    async getOptionJabatan() {
      this.optionJabatan = this.jabatan.map((item) => {
        return {
          id: item.id,
          text: item.name,
        };
      });
    },
    async getJabatan() {
      this.$store.state.loading = true;
      await JabatanApi.get().then((response) => {
        this.jabatan = response.data;
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: "ERROR",
          text: error?.response?.data?.message ?? "Belum ada jabatan"
        });
      });
      await this.getOptionJabatan();
      this.$store.state.loading = false;
    },
    myChangeEvent(val) {
      console.log(val);
    },
    mySelectEvent({ id, text }) {
      console.log({ id, text })
    },
    validateRange(index, state) {
      let value = this.data?.['nilai' + index + '_' + state]
      let prev = this.data?.['nilai' + (state == 'max' ? String(index) : String(index - 1)) + '_' + (state == 'max' ? 'max' : 'min')] ?? '-999999999';
      let next = this.data?.['nilai' + (state == 'max' ? String(index + 1) : String(index)) + '_' + (state == 'max' ? 'min' : 'max')] ?? '999999999';
      let prev_op = this.data?.['nilai' + (state == 'max' ? String(index) : String(index - 1)) + '_' + (state == 'max' ? 'max' : 'min' + '_operator')] ?? '<=';
      let next_op = this.data?.['nilai' + (state == 'max' ? String(index + 1) : String(index)) + (state == 'max' ? 'min' : 'max') + '_operator'] ?? '>=';
      console.log([prev, prev_op, value, next_op, next].join(''))
      return true;
    },
    async submit() {
      if (!this.submitable) {
        this.$swal({
          icon: "error",
          title: "Form Belum Lengkap",
        })
        return false;
      }
      else {
        for (let index = 1; index <= 5; index++) {
          if (this[`error_aspek_${index}`] == true) {
            this.$swal({
              icon: "error",
              title: "Invalid range",
            })
            return false;
          }
        }
        this.$store.state.loading = true;
        for (let index = 1; index <= 5; index++) {
          if (!this.validateRange(index, this.data?.['nilai' + index + '_min_operator'], this.data?.['nilai' + index + '_max_operator'])) {
            return false;
          }
        }
  
        if (this.$route.params.id) {
          await AspekKinerjaApi.update(this.$route.params.id, this.data).then(() => {
            this.$swal({
              icon: "success",
              title: "Berhasil",
            }).then(() => {
              this.$router.push({ name: "Aspek KPI" });
            }).catch((error) => {
              this.$swal({
                icon: "error",
                title: error.response.data.message,
              });
            });
          })
        }
        else {
          await AspekKinerjaApi.post(this.data).then(() => {
            this.$swal({
              icon: "success",
              title: "Berhasil",
            }).then(() => {
              this.$router.push({ name: "Aspek KPI" });
            });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: error.response.data.message,
            });
          });
        }
        this.$store.state.loading = false;
      }
    },
    async getData() {
      this.$store.state.loading = true;
      await AspekKinerjaApi.get(this.$route.params.id).then((response) => {
        this.data = response.data;
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: error?.response?.data?.message,
        }).then(() => {
          this.$router.push({ name: "Periode KPI" });
        });
      });
      this.$store.state.loading = false;
    }
  },
};
</script>
